import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetForingLang, GetPackages, GetOneLearningLanguage, GetInterfaceLang, GetOneInterfaceLang, delPackage, GetPackageOne} from '../../actions/index';

class PackageOne extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.addPackage = this.addPackage.bind(this);
        this.renderIcon = this.renderIcon.bind(this);
        this.editPackage = this.editPackage.bind(this);
        this.delChatPackageOpenModal = this.delChatPackageOpenModal.bind(this);
        this.delPackageInModal = this.delPackageInModal.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        let package_id = localStorage.getItem('id_package');
        this.props.GetForingLang(token);
        this.props.GetOneInterfaceLang(token, package_id);
        this.props.GetInterfaceLang(token);
        this.props.GetOneLearningLanguage(package_id, token);
        this.props.GetPackages(token, package_id);
    }
    componentWillUnmount(){
        this.props.subscription.package_one = {};
    }
    addPackage(id){
        this.context.router.push('/subscription/packages/package/add/');
    }
    editPackage(id){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetPackageOne(token, id);
        this.context.router.push('/subscription/packages/package/edit/' + id +'/');
    }
    delChatPackageOpenModal(id){
        let token = localStorage.getItem('id_token_admin');
        $('#delPackage').modal('show');
        this.props.GetPackageOne(token, id);
    }
    closeModal(){
        $('#delPackage').modal('hide');
    }
    delPackageInModal(){
        let token = localStorage.getItem('id_token_admin');
        let package_id = localStorage.getItem('id_package');
        this.props.delPackage(token, this.props.subscription.package_one.id).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.props.GetPackages(token, package_id);
            }
        });
    }
    renderIcon(item){
        return item.map((code)=>{
            if(code.description != '') {
                return this.props.lang.interface_lang.results.map((lang) => {
                    if(lang.id == code.blang){
                        return <i>{lang.lang.code}</i>
                    }
                });
            }
        });
    }
    getTitleById(id, translations) {
        let result = '';
        translations.forEach(function(item, i){
            if(item.blang == id) {
                result = item.title;
            }
        });
        if(result == ''){
            translations.forEach(function(item, i){
                if(item.blang == 1) {
                    result = item.title;
                }
            });
            return result
        }else{
            return result
        }
    }
    renderTable(id){
        let newArr = this.props.subscription.packages.results.sort(function (a, b) {
            return parseInt(a.position) - parseInt(b.position);
        });
        return newArr.map((item, i)=>{
            let title = this.getTitleById(parseInt(id), item.translations);
            return(
                <div key={item.id} className="white-block common-list clearfix two">
                    <p>{i+1}</p>
                    <p className="common-item-with-tag">
                        <span className="link-span" onClick={this.editPackage.bind(this, item.id)}>{title}</span>
                        {this.props.lang.interface_lang.results ? this.renderIcon(item.translations) : ""}
                    </p>
                    <p className="pull-right">
                        <button type="button" onClick={this.editPackage.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true"></span>
                        </button>
                        <button type="button" onClick={this.delChatPackageOpenModal.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-trash"></span>
                        </button>
                    </p>
                </div>
            )
        })
    }
    render() {
        let package_id = localStorage.getItem('id_package');
        return (

            <div>
                <div className="dashboard-wrapper">
                    <div className="dashboard-title clearfix">
                        <div className="pull-left">
                            <p className="dashboard-title">{package_id && this.props.lang.learning_lang_one.lang ? this.props.lang.learning_lang_one.lang.name : "Add Package"}</p>
                            <p className="dashboard-text">Subscription</p>
                        </div>
                        <div className="pull-right dashboard-title">
                            <button onClick={this.addPackage} type="button" className="btn btn-primary">
                                <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                Add package
                            </button>
                        </div>
                    </div>
                    {this.props.subscription.packages.results && this.props.subscription.packages.results.length > 0  ?
                        <div>
                            <div className="col-md-12">
                                <div className="common-list clearfix two">
                                    <p>#</p>
                                    <p>Name</p>
                                    <p className="pull-right">Option</p>
                                </div>
                            </div>
                            <div className="col-md-12">
                                { this.renderTable(package_id) }
                            </div>
                        </div>
                        :
                        <div className={this.props.subscription.packages.results && this.props.subscription.packages.results.length < 0 || $.isEmptyObject(this.props.subscription.packages) ? "for_preloader" : 'for_preloader dn'}>
                            <div className="preloader-wrapper big active">
                                <div className="spinner-layer spinner-blue-only">
                                    <div className="circle-clipper left">
                                        <div className="circle" />
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle" />
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.subscription.packages.results && this.props.subscription.packages.results.length === 0 && <p className="noResults">No items result</p>}

                    <div className="modal fade" id="delPackage" tabIndex="-1" role="dialog" aria-labelledby="DelPackageLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#delPackage"></span>
                                    <p>Do you really want to delete this package?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delPackageInModal} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}


function  mapStateToProps(state) {
    return{
        subscription: state.subscription,
        lang: state.lang
    }
}
export default connect(mapStateToProps, {GetForingLang, GetPackages, GetOneLearningLanguage, GetInterfaceLang, GetOneInterfaceLang, delPackage, GetPackageOne})(PackageOne);



// WEBPACK FOOTER //
// ./src/components/subscription/packageOne.js